{
  "user": {
    "title": "Panel",
    "greeting": "Bienvenido de nuevo",
    "greetingNamed": "Bienvenido de nuevo, {{name}}",
    "description": "Ve a un ajuste o retoma donde lo dejaste.",
    "quickActions": "Acciones rápidas",
    "accountTitle": "Cuenta",
    "accountDescription": "Actualiza tu perfil y tus datos personales.",
    "securityTitle": "Seguridad",
    "securityDescription": "Gestiona tu contraseña y la autenticación de dos factores.",
    "notificationsTitle": "Notificaciones",
    "notificationsDescription": "Elige cómo y cuándo contactarte.",
    "activityTitle": "Actividad reciente",
    "activityEmptyTitle": "Sin actividad reciente",
    "activityEmptyDescription": "Tu actividad reciente aparecerá aquí."
  },
  "admin": {
    "title": "Resumen de administración",
    "greeting": "Bienvenido de nuevo",
    "greetingNamed": "Bienvenido de nuevo, {{name}}",
    "description": "Administración de la plataforma de un vistazo.",
    "quickActions": "Gestionar",
    "usersTitle": "Usuarios",
    "usersDescription": "Visualiza, invita y gestiona a los usuarios de la plataforma.",
    "tenantsTitle": "Inquilinos",
    "tenantsDescription": "Configura los inquilinos y su marca.",
    "analyticsTitle": "Analíticas",
    "analyticsDescription": "Sigue el uso y las métricas de la plataforma.",
    "siteTitle": "Sitio",
    "siteDescription": "Edita y publica el sitio de marketing.",
    "featureFlagsTitle": "Indicadores de funciones",
    "featureFlagsDescription": "Despliega funciones entre inquilinos y usuarios.",
    "pluginsTitle": "Complementos",
    "pluginsDescription": "Gestiona los complementos instalados y su disponibilidad."
  },
  "metrics": {
    "heading": "Resumen",
    "chartsHeading": "Actividad",
    "totalUsers": "Usuarios totales",
    "apiUsage": "Solicitudes de API",
    "errorRate": "Tasa de errores",
    "errorRateElevated": "Por encima del umbral esperado",
    "growth": "Usuarios nuevos",
    "featureUsage": "Uso de funciones",
    "attention": "Atención",
    "apiUsageChart": "Solicitudes de API por ruta",
    "featureUsageChart": "Uso de funciones",
    "chartEmpty": "Sin datos para este rango"
  },
  "range": {
    "label": "Rango de tiempo",
    "24h": "Últimas 24 horas",
    "24h_short": "24 h",
    "7d": "Últimos 7 días",
    "7d_short": "7 d",
    "30d": "Últimos 30 días",
    "30d_short": "30 d"
  },
  "state": {
    "loading": "Cargando las métricas del panel",
    "emptyTitle": "Aún no hay analíticas",
    "emptyBody": "Las métricas aparecerán aquí a medida que las personas usen tu aplicación.",
    "errorTitle": "No pudimos cargar tus métricas",
    "errorBody": "Algo salió mal al cargar las métricas del panel. Inténtalo de nuevo.",
    "retry": "Reintentar"
  }
}
